import { MOKA_SERVICE_HOST } from '../constants';

export const SYNC_BILL_SERVICE_URL = `${MOKA_SERVICE_HOST}/sync-bill/v1`;
